import React from "react";
import classes from "./Section5.module.css";
import { Link } from "react-router-dom";

const cards = [
  {
    icon: "/img/about-us-img/certified-coders.svg",
    title: "Certified Coders",
    description:
      "Our AAPC certified team delivers detailed and accurate work, training your staff for increased revenue.",
  },
  {
    icon: "/img/about-us-img/experience.svg",
    title: "Experience",
    description:
      "We have experience in medical billing, our team has developed strong relationships and consistently delivers results.",
  },
  {
    icon: "/img/about-us-img/personalized-services.svg",
    title: "Personalized Services",
    description:
      "Led by our team, we simplify the billing process for timely reimbursement.",
  },
  {
    icon: "/img/about-us-img/up-to-date.svg",
    title: "Up To Date",
    description:
      "We stay current with regulations, compliance, and industry changes to tailor our services to your needs.",
  },
];

export default function Section5() {
  return (
    <section className={classes.mainSection5Wrapper}>
      <div className={`container ${classes.section5Wrapper}`}>
        {/* First row: Title & Description */}
        <div className={classes.section5Row}>
          <h2 className={classes.section5Title}>
            Your Trusted Medical Billing Consulting Team
          </h2>
          <p className={classes.section5Description}>
            At PSP, our team of experts specializes in{" "}
            <Link to="/services/medical-billing/" style={{ color: "#fff" }}>
              expert medical billing consulting
            </Link>
            , revenue cycle management (RCM), and healthcare practice growth.
            With decades of experience, we have helped over 200 providers across
            specialties like cardiology, neurology, pediatrics, and more improve
            profitability and efficiency. Our services include medical coding,
            billing optimization, contract negotiation, and practice
            development. Using advanced technology and proven strategies, we
            help your practice grow efficiently and achieve long-term success.
          </p>{" "}
        </div>

        {/* Second row: Cards */}
        <div className={classes.section5CardGrid}>
          {cards.map((card, idx) => (
            <div key={idx} className={classes.section5Card}>
              <img
                src={card.icon}
                alt={card.title}
                className={classes.section5CardIcon}
              />
              <div className={classes.section5CardContent}>
                <h3 className={classes.section5CardTitle}>{card.title}</h3>
                <p className={classes.section5CardDescription}>
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Third row: Images */}
        <div className={classes.section5Images}>
          <div className={classes.section5ImageWrapper}>
            <img
              src="/img/about-us-img/about-our-team-1.webp"
              alt="About Our Team 1"
              className={classes.section5Image}
            />
          </div>
          <div className={classes.section5ImageWrapper}>
            <img
              src="/img/about-us-img/about-our-team-2.webp"
              alt="About Our Team 2"
              className={classes.section5Image}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
